import MicroModal from 'micromodal';

class Gallery {
	constructor(root) {
		this.root = root;
		this.getElements();
		if (this.galleryWrapper && this.galleryModal) {
			this.initElements();
			this.init();
		}
	}

	getElements = () => {
		this.galleryWrapper = this.root.querySelector('.gallery-container');
		this.galleryModal = this.root.querySelector('.gallery-modal');
	};

	initElements = () => {
		this.images = this.galleryWrapper.querySelectorAll('.gallery-images-image');
		this.swiper = this.galleryModal.querySelector('.modal-swiper');
		this.left = this.galleryModal.querySelector('#gallery-modal-left');
		this.right = this.galleryModal.querySelector('#gallery-modal-right');
	};

	init = () => {
		MicroModal.init({
			disableScroll: true,
			// debugMode: true,
		});

		this.swiperObj = new Swiper(this.swiper, {
			slidesPerView: 1,
			grabCursor: true,
			spaceBetween: 30,
			navigation: {
				nextEl: this.right,
				prevEl: this.left,
			},
		});

		this.images.forEach((image) => {
			image.addEventListener('click', () => {
				this.swiperObj.slideTo(image.dataset.id, 0);
				this.showModal();
			});
		});
	};

	showModal = () => {
		MicroModal.show(this.galleryModal.id);
	};
}

new Gallery(document);
